import React from 'react';
import './Badges.css';

/* Badge de CANAL de venta (F2) — discreto, con el color por canal de tokens.css.
   Acepta el nombre tal como viene de saleschannels ("Tienda física", "Web",
   "Feria", "WhatsApp") o la key ya normalizada. Canal desconocido → neutral. */
const CANAL_KEY = {
  'tienda física': 'tienda-fisica',
  'tienda fisica': 'tienda-fisica',
  web: 'web',
  feria: 'feria',
  whatsapp: 'whatsapp',
  ia: 'ia',
};

export default function ChannelBadge({ channel = '', className = '' }) {
  const key = CANAL_KEY[String(channel).trim().toLowerCase()] || 'neutral';
  return (
    <span className={`ui-channel-badge ui-channel-badge--${key}${className ? ` ${className}` : ''}`}>
      {channel || '—'}
    </span>
  );
}
